import Vue from 'vue';
Vue.config.productionTip = false;
import App from './App.vue';
import router from './router';
import apolloProvider from './apollo';
import Component from 'vue-class-component';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
]);
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faArrowUp);
Vue.component('font-awesome-icon', FontAwesomeIcon);
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    locale: 'en',
    locales: {
        'en': {
            firstDayOfWeek: 1,
            masks: {
                L: 'DD/MM/YYYY',
            }
        }
    }
});
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import '@/assets/metronic/css/demo11/style.bundle.css';
import 'tether/dist/css/tether.css';
import '@/assets/metronic/vendors/custom/vendors/line-awesome/css/line-awesome.css';
import '@/assets/metronic/vendors/custom/vendors/flaticon/flaticon.css';
import '@/assets/metronic/vendors/custom/vendors/flaticon2/flaticon.css';
new Vue({
    router,
    apolloProvider,
    render: h => h(App)
}).$mount('#app');
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_REMOTE_ENV === 'development') {
    alert("Friendly reminder: This is the development version. Changes won't be reflected on the real app.");
}
